// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file_listing {
  list-style: none;
  margin-top: 16px;
}
.file_listing .file__li_item {
  display: flex;
  gap: 8px;
  height: 40px;
  align-items: center;
  justify-content: space-between;
}
.file_listing .file__li_item .file__li_item_title {
  flex: 1 1;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/PatientDetailsPageFormDrawer/PatientDetailsPageFormDrawer.scss"],"names":[],"mappings":"AAGA;EACI,gBAAA;EACA,gBAAA;AAFJ;AAGI;EACI,aAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;AADR;AAEQ;EACI,SAAA;EACA,gBAAA;AAAZ","sourcesContent":["@import \"../../../styles/colors\";\r\n@import \"../../../styles/_typography.scss\";\r\n\r\n.file_listing {\r\n    list-style: none;\r\n    margin-top: 16px;\r\n    .file__li_item {\r\n        display: flex;\r\n        gap: 8px;\r\n        height: 40px;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        .file__li_item_title {\r\n            flex: 1;\r\n            text-align: left;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
